module.exports = __webpack_public_path__ + "img/24-7.d253f119.png";